import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectsRoles() {
      return getState().projectResources;
    },
    isRetrieveProjectsRolesRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveProjectsRolesRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveProjectsRolesRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
